import TourProductsRepository from '@/js/common/Domain/Repository/TourProducts';
import groupProductsByCriterias from '@/js/common/Domain/Service/groupProductsByCriterias';

export default (tourProducts) => {
    if (!tourProducts?.length) return [];

    const groupedByHash = groupProductsByCriterias(tourProducts);
    const productMappedWithSimilar = _
        .chain(groupedByHash)
        .map((groupedByhashProducts) => {
            const [firstProduct, ...otherProducts] = groupedByhashProducts;
            firstProduct.set('similarProducts', otherProducts);
            return firstProduct;
        })
        .value();

    return new TourProductsRepository(productMappedWithSimilar);
};